export enum HEADING_TYPES {
	h1,
	h2,
	h3,
	h4
	// h5 and h6 are intentionally omitted! If you're considering 5th or 6th level content importance,
	// you should not be using a heading. Instead, use a div, p, or another HTMLElement.
}

export enum HEADING_SIZES {
	xl,
	lg,
	md,
	sm,
	xs
}
